import { useTranslations } from "next-intl";
import { useReferralProgram } from "@hooks/use-features";
import { useCurrentUser } from "@hooks/use-current-user";
import { usePrice } from "@hooks/use-prices";
import ReferralShareLink from "@components/views/Profile/Referral/ReferralShareLink";
import redeemTypes from "@utils/constants/redeemTypes";

function FooterReferral() {
  const t = useTranslations("common");
  const {
    referree_coupon: referreeCoupon,
    referrer_subscription_credit_reward: referrerRewardInCents,
  } = useReferralProgram();
  const user = useCurrentUser();
  const price = usePrice();

  const durationInMonths = parseInt(referreeCoupon?.duration_in_months, 10) || 1;

  if (!user?.referring_token) return null;

  const referreeGainText = () => {
    switch (referreeCoupon.duration) {
      case "forever":
        switch (referreeCoupon.type) {
          case redeemTypes.couponPercentOff:
            return t.rich("referral.referree_gain.percent_off_forever", {
              percent: referreeCoupon.value,
              span: (chunks) => <span className="font-size-lg">{chunks}</span>,
            });
          case redeemTypes.couponAmountOff:
            return t.rich("referral.referree_gain.amount_off_forever", {
              amount: price(referreeCoupon.value, { withoutCents: true, withoutSpace: true }),
              span: (chunks) => <span className="font-size-lg">{chunks}</span>,
            });
        }
        break;
      case "once":
      case "repeating":
        switch (referreeCoupon.type) {
          case redeemTypes.couponPercentOff:
            return t.rich("referral.referree_gain.percent_off", {
              percent: referreeCoupon.value,
              count: durationInMonths,
              span: (chunks) => <span className="font-size-lg">{chunks}</span>,
            });
          case redeemTypes.couponAmountOff:
            return t.rich("referral.referree_gain.amount_off", {
              amount: price(referreeCoupon.value, { withoutCents: true, withoutSpace: true }),
              count: durationInMonths,
              span: (chunks) => <span className="font-size-lg">{chunks}</span>,
            });
        }
        break;
    }
  };

  return (
    <div className="bg-white p-3 text-center rounded-lg">
      <h5 className="mb-2">{t("referral.footer_title")}</h5>
      <h6 className="text-primary mb-0">
        {t.rich("referral.referrer_gain", {
          amount: price(referrerRewardInCents, { withoutCents: true, withoutSpace: true }),
          span: (chunks) => <span className="font-size-lg">{chunks}</span>,
        })}
      </h6>
      <h6 className="mb-3">{referreeGainText()}</h6>

      <div className="d-flex flex-column justify-content-center align-items-center">
        <ReferralShareLink
          trackingName="profileShareReferral"
          size="sm"
        />
      </div>
    </div>
  );
}

export default FooterReferral;
